<template>
<div id="aduanas" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Transmisión de eDocument" class="elevation-1 px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>

                        <v-btn fab dark x-small v-if="valida_permiso('VUCEM.Transmision.nuevo.edocument') || valida_permiso('MVs.transmision.edocument')" color="secondary" slot="activator" @click.native="openModal(1)" title="Nuevo eDocument" v-tippy>
                            <v-icon dark>present_to_all</v-icon>
                        </v-btn>
                        <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >edit</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Nuevo eDocument</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center>
                                        <v-form ref="form" lazy-validation>
                                            <v-card-text>
                                                <v-container grid-list-md text-xs-center @keyup.enter="send()" >
                                                    <v-layout row wrap>
                                                        <v-flex s6 m6 l6>
                                                            <v-text-field label="Nombre de Proceso" type="text" v-model="model.nombre_proceso" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s6 m6 l6>
                                                            <v-autocomplete v-model="model.tipo_documento" :items="tiposDocumentos" :hide-no-data="true" :hide-selected="true" :return-object="false" item-text="nombre_completo" item-value="clave" label="Seleccione Tipo Documento" :rules="[rules.required]" >
                                                            </v-autocomplete>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s6 m6 l6>
                                                            <v-text-field label="Nombre Documento" type="text" v-model="model.nombre_documento" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s6 m6 l6>
                                                            <v-checkbox v-model="agentes" label="Mostrar Catálogo de Agentes Aduanales" ></v-checkbox>
                                                               <v-autocomplete v-if="agentes" :hide-no-data="true" :items="rfcs_consulta" v-model="model.rfc_consulta" :item-text="getNombreRfcConsulta" item-value="rfc"
                                                                 label="RFC Consulta"></v-autocomplete>
                                                              <v-text-field v-if="!agentes" label="RFC Consulta" type="text" v-model="model.rfc_consulta" @input="model.rfc_consulta = model.rfc_consulta.toUpperCase()" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s6 m6 l6>
                                                            <v-text-field label="Email de Respuesta" type="text" v-model="model.email" :rules="[rules.required, rules.email]" maxlength="100" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s6 m6 l6>
                                                            <span class="v-label theme--light font-weight-bold left" >Archivo PDF</span>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s6 m6 l6>
                                                            <file-pond allowPaste=false name="certificado" ref="pond" required class-name="my-pond" labelIdle="<span class='filepond--label-action'> Arrastre o seleccione su archivo .pdf   Aqui </span>" labelInvalidField="Archivo no valido" labelFileWaitingForSize="Calculando el tamaño" labelFileSizeNotAvailable="Tamaño no valido" labelFileLoading="Cargando.." labelFileLoadError="Error al cargar" labelFileProcessing="Subiendo" labelFileProcessingComplete="Carga completa" labelFileProcessingAborted="Carga cancelada" labelFileProcessingError="Error durante la carga" labelFileProcessingRevertError="Error" labelFileRemoveError="Error al eliminar" labelTapToCancel="Cancelar" labelTapToRetry="Reintentar" labelTapToUndo="Deshacer" labelButtonRemoveItem="Eliminar" labelButtonAbortItemLoad="Abortar" labelButtonRetryItemLoad="Reintentar" labelButtonAbortItemProcessing="Cancelar" labelButtonUndoItemProcessing="Deshacer" labelButtonRetryItemProcessing="Reintentar" labelButtonProcessItem="Subir" accepted-file-types=".pdf" v-bind:files="file_cer" v-bind:server="myServerCER" allowFileTypeValidation />
                                                        </v-flex>
                                                    </v-layout>

                                                </v-container>
                                            </v-card-text>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal=false" >
                                        <v-icon>cancel</v-icon>Cancelar
                                        </v-btn>
                                        <v-btn color="success" :loading="loading" @click.native="send()" >
                                            <v-icon>done</v-icon>Guardar
                                        </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()">
                            
                            <v-refresh-button :funcion="cargarTabla" />
                            
                            <v-client-table ref="vuetable" id="lista_edocuments" :data="registros.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="fecha" slot-scope="props" >
                                    {{parseDate(props.row.fecha)}}
                                </template>
                                <template slot="fecha_envio" slot-scope="props" >
                                    {{parseDate(props.row.fecha_envio)}}
                                </template>
                                <template slot="estatus" slot-scope="props" >
                                    {{getEstatus(props.row.estatus)}}
                                </template>
                                <template slot="tipo_documento" slot-scope="props" >
                                    {{getTipoDocumento(props.row.tipo_documento)}}
                                </template>

                                <template slot="pdf" slot-scope="props" >
                                    <span v-if="props.row.pdf==0" >Pendiente</span>
                                    <span v-if="props.row.pdf==1" >En cola</span>
                                    <span v-if="props.row.pdf==3" >Error al generar</span>
                                    <span v-if="props.row.pdf==4" >No recuperable</span>
                                    <v-btn text icon color="primary" title="Descargar PDF" v-if="(props.row.pdf==2 && props.row.nombre_edocument!=null && props.row.nombre_edocument!='')" @click="downloadFile('original_'+props.row.nombre_edocument, props.row.no_operacion, 'pdf')" >
                                        <v-icon dark>picture_as_pdf</v-icon>
                                    </v-btn>
                                </template>

                                <template slot="acuse" slot-scope="props" >
                                    <span v-if="(props.row.acuse==0 && props.row.nombre_edocument==null)" >Pendiente</span>
                                    <v-btn text icon color="primary" title="Descargar Acuse" v-if="(props.row.acuse==99 || (props.row.acuse==0 && props.row.nombre_edocument!=null && props.row.nombre_edocument!=''))" @click="recuperarAcuse(props.row.id, props.row.no_operacion, props.row.nombre_edocument)" >
                                        <v-icon dark>get_app</v-icon>
                                    </v-btn>
                                    <span v-if="props.row.acuse==1" >En cola</span>
                                    <span v-if="props.row.acuse==3" >Error al recuperar</span>
                                    <span v-if="props.row.acuse==4" >No recuperable</span>
                                    <v-btn text icon color="primary" title="Descargar PDF" v-if="(props.row.acuse==2 && props.row.nombre_edocument!=null && props.row.nombre_edocument!='')" @click="downloadFile('Acuse_'+props.row.nombre_edocument, props.row.no_operacion, 'pdf')" >
                                        <v-icon dark>picture_as_pdf</v-icon>
                                    </v-btn>
                                </template>

                                <template slot="evidencias" slot-scope="props">
                                    <v-btn text icon color="primary" title="ZIP Evidencia" v-if="props.row.estatus!=0" @click="downloadZipEvidencia(props.row.id, props.row.no_operacion)">
                                        <v-icon dark>get_app</v-icon>
                                    </v-btn>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    
                                    <v-speed-dial  :key="props.row.id" direction="left" open-on-hover v-if="(props.row.error==undefined || props.row.error=='') && props.row.estatus != 1" >
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary" >
                                                <v-icon v-if="fab" >mdi-close</v-icon>
                                                <v-icon v-else>reorder</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-btn x-small fab dark color="blue" v-if="(props.row.error==undefined || props.row.error=='') && props.row.estatus != 1 && (valida_permiso('VUCEM.Transmision.nuevo.edocument') || valida_permiso('MVs.transmision.edocument'))" @click.native="transmitir(props.row.id)" title="Transmitir eDocument" v-tippy>
                                            <v-icon>send</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" v-if="props.row.estatus == 0 && (valida_permiso('VUCEM.Transmision.nuevo.edocument') || valida_permiso('MVs.transmision.edocument') )" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                            <template>
                                <div v-if="pwPagination.total > 0" >
                                    <div class="mt-3" >
                                        <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="registros" :options="pwPagination.options" ></PaginacionComponent>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!--div>
                            <v-card class="default " style="font-size:11px;" >
                                <span class="" >
                                    <strong>ESTATUS<br />
                                        Pendiente:</strong> Pendiente de encolar para su recuperación.<br />
                                    <strong>En cola:</strong> Ya encolado para su recuperación.<br />
                                    <strong>Error al recuperar:</strong> Ocurrió un error al recuperar el eDocument.<br />
                                    <strong>No recuperable:</strong> No es posible recuperar el eDocument.<br />
                                </span>
                            </v-card>
                        </div-->
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
import PaginacionComponent from '@/components/PaginacionComponent.vue';
// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
// Import styles
import "filepond/dist/filepond.min.css";

import axios from "axios";

// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType);
import moment from "moment";
export default {
    components: {
        "v-refresh-button": RefreshButton,        
        "PaginacionComponent": PaginacionComponent,
        FilePond
    },    
    data: function () {
        return {
            agentes:false,
            model_filters: '',
            pwPagination: {
                total: 0,
                links: {                                        
                    url: "https://apivucem.econnectpro.mx/transmitir_edocument/get_edocuments/",                    
                    next: '',
                    prev: '',
                },
                options: {
                    tipo: 1,
                    size: 10,
                    loading: this.showLoading,
                    filters: {}
                }
            },
            fab: false,
            name: "datagrid",
            ws_password: '',
            rfcs_consulta:[],
            columns: [
                "fecha",
                "nombre_proceso",
                "nombre_documento",
                "tipo_documento",
                "email",
                "fecha_envio",
                "no_operacion",
                "nombre_edocument",
                "enviado_por",
                "estatus",
                "error",
                "pdf",
                "acuse",
                "evidencias",
                "actions"
            ],
            options: {
                filterable: [
                    "fecha",
                    "nombre_proceso",
                    "nombre_documento",                    
                    "email",
                    "fecha_envio",
                    "no_operacion",
                    "nombre_edocument",
                    "enviado_por",                    
                    "error",
                ],
                sortable: [
                    "fecha",
                    "nombre_proceso",
                    "nombre_documento",
                    "tipo_documento",
                    "email",
                    "fecha_envio",
                    "no_operacion",
                    "nombre_edocument",
                    "enviado_por",
                    "estatus",
                    "error",
                    "pdf",
                    "acuse",
                ],

                headings: {
                    fecha: "Fecha",
                    nombre_proceso: "Nombre de Proceso",
                    nombre_documento: "Nombre Documento",
                    tipo_documento: "Tipo Documento",
                    fecha_envio: "Fecha de Envío",
                    email: "Email Respuesta",
                    no_operacion: "No. Operación",
                    nombre_edocument: "eDocument",
                    enviado_por: "Enviado Por",
                    estatus: "Estatus Transmisión",
                    error: "Error Tranmisión",
                    pdf: "PDF",
                    acuse: "Acuse",
                    actions: "Operaciones",
                },
                uniqueKey: "id",
            },
            URL: "",
            show_loading: true,
            loading: false,
            title: "",
            modal: false,
            update: false,
            rfc: "",
            search: "",

            rules: {
                required: v => !!v || "Este campo es requerido",
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Correo electrónico no valido";
                },
            },
            tiposDocumentos: [],
            registros: {
                selected: [],
                items: [],
            },
            file_cer: [],
            cliente: null,
            usuario: null,
            file_c: null,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Vucem-Transmisión",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Transmitir eDocument",
                    disabled: true,
                    to: ""
                }
            ],
            loading: false,
            modal: false,
            search: "",
            model: {
                tipo_documento: "",
                nombre_proceso: "",
                nombre_documento: "",
                rfc_consulta: "",
                email: "",
                clave_ws: "",
                password: ""
            },
            myServerCER: {
                process: (fieldName, file, metadata, load) => {
                    //this.file_c = file;
                    let name = file.name.toUpperCase().split(".PDF")[0];
                    let flag = true;
                    const pattern = /^[A-Za-z0-9 _]+$/;
                    if(!pattern.test(name)) {
                      this.$swal({
                          type: "warning",
                          title: "Advertencia",
                          text: "El nombre del archivo solo puede contener letras, números y espacios",
                          footer: ""
                      });
                      flag = false;
                    }

                    const fr = new FileReader();
                    fr.readAsDataURL(file);
                    fr.addEventListener('load', () => {
                        if(flag){
                            this.file_c = fr.result; // archivo en base64
                        } else {
                          this.file_c = null;
                          this.$refs.pond.removeFiles();
                        }
                    });

                    // simulates uploading a file
                    setTimeout(() => {
                        load(Date.now());
                    }, 5);
                },
                load: (source, load) => {
                    // simulates loading a file from the server
                    fetch(source)
                        .then(res => res.blob())
                        .then(load);
                }
            },

        };
    },
    mounted: function () {
        this.model_filters = this.$refs.vuetable.query;        
    },
    watch: {
        model_filters: {
            handler(val) {
                this.pwPagination.options.filters = {
                    rfc: this.$local_storage.get("rfc"),                    
                    filtros: {                        
                        fecha__gte: this.model_filters.fecha, //Debe ser la fecha completa 2024-04-16
                        fecha_envio__gte: this.model_filters.fecha_envio,
                        nombre_proceso__icontains: this.model_filters.nombre_proceso,
                        nombre_documento__icontains: this.model_filters.nombre_documento,
                        tipo_documento__icontains: this.model_filters.tipo_documento,
                        email__icontains: this.model_filters.email,
                        no_operacion__icontains: this.model_filters.no_operacion,
                        nombre_edocument__icontains: this.model_filters.nombre_edocument,
                        enviado_por__icontains: this.model_filters.enviado_por,
                        estatus: this.model_filters.estatus,
                        error__icontains: this.model_filters.error,
                    }
                }                
            },
            deep: true
        }        
    },
    methods: {
        cargarTabla: function(){
            this.$refs.pagination_pw.filterData();
        },
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        validaLetrasNumeros: function (nombre) {
            if (nombre) {
                const pattern = /^[A-Za-z0-9 ]+$/;
                if(!pattern.test(nombre)) {
                  return "Solo se acepta letras, números y espacios";
                }
            }
            return true;
        },
        openModal: function (type) {
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },

        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.post("https://apivucem.econnectpro.mx/transmitir_edocument/get_edocuments/", {
                    rfc: this.rfc
                })
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        
                        this.pwPagination.total = res.data.count;
                        this.pwPagination.links.next = res.data.next;
                        this.pwPagination.links.prev = res.data.previous;

                        this.registros.items = res.data.results;
                        this.registros.items.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha);
                        });
                        /*for (var k in this.registros.items) {
                            this.registros.items[k].fecha = this.parseDate(this.registros.items[k].fecha);
                            this.registros.items[k].fecha_envio = this.parseDate(this.registros.items[k].fecha_envio);
                            this.registros.items[k].estatus = this.getEstatus(this.registros.items[k].estatus);
                            this.registros.items[k].tipo_documento = this.getTipoDocumento(this.registros.items[k].tipo_documento);
                        }*/

                    }
                })
                .catch(err => {

                    console.log(err);
                }).then(() => {
                    this.cargarCertificados();
                    this.$root.$dialogLoader.hide();
                });
        },
        getEstatus: function (estatus) {
            var arr_estatus = ["Sin transmitir", "Transmitido correctamente", "Transmitido con errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getTipoDocumento: function (clave) {
            var filtered = this.tiposDocumentos.filter(el => {
                return el.clave == clave;
            });
            if (filtered.length > 0)
                return filtered[0].clave + " - " + filtered[0].descripcion;
            else
                return "N/A";
        },
        cargarTiposDocumento: function () {
            axios.post(this.$hostname + "apendices/lista/", {
                    tabla: 25
                })
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.tiposDocumentos = res.data;
                        this.tiposDocumentos = this.tiposDocumentos.filter(item => {
                                        return parseInt(item.clave) > 0
                         });
                        for (var k in this.tiposDocumentos) {
                            this.tiposDocumentos[k].nombre_completo = this.tiposDocumentos[k].clave + " - " + this.tiposDocumentos[k].descripcion;
                        }

                    }
                })
                .catch(err => {

                    console.log(err);
                }).then(() => {

                });
        },
        cargarCertificados: function () {
            var rfc = this.$local_storage.get("rfc");
            var datos = {
                cliente: this.cliente
            };
            axios
                .post(this.$hostname + "catalogos/certificados/list_certificados/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.sellos = res.data;
                        if (this.sellos.length > 0) {
                            var search = this.sellos.filter(function (e) {
                                return e.estatus == 1 && e.activo == true; //1-Sello correcto
                            });
                            if (search.length > 0) {
                                let sello = search[0];
                                this.ws_password = sello.clave_ws;
                            } else {
                                var search2 = this.sellos.filter(function (e) {
                                    return e.estatus == 0 && e.activo == true; //0-Sello sin probar
                                });
                                if (search2.length > 0) {
                                    let sello = search2[0];
                                    this.ws_password = sello.clave_ws;
                                } else {
                                    this.$swal({
                                        type: "warning",
                                        title: "Advertencia",
                                        text: "El cliente: " + rfc + " no tiene sellos digitales validados. Favor de verificar.",
                                        footer: ""
                                    });

                                }
                            }
                        } else {
                            this.$swal({
                                type: "warning",
                                title: "Advertencia",
                                text: "No se han configurado sellos digitales para el cliente: " + rfc,
                                footer: ""
                            });
                        }
                    }
                })
                .catch(err => {

                });
        },

        transmitir: function (row_id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let datos = {
                id: row_id,
                usuario: this.usuario,
                id_cliente: this.cliente,
                rfc: this.rfc,
                usuario_email: this.$local_storage.get("email")
            };
            axios
                .post(this.URL + "transmitir/", datos)
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Se ha iniciado el proceso de transmisión. Recibirá una notificación cuando el resultado esté disponible.",
                        footer: ""
                    });
                })
                .catch(err => {
                    //console.log(err.response);
                    var errores = "";
                    if (err.response.data != undefined) {
                        if (err.response.data.mensaje != undefined) {
                            if (typeof err.response.data.mensaje == "string")
                                errores += err.response.data.mensaje;
                            else
                                errores += err.response.data.mensaje[0];

                        } else {
                            Object.keys(err.response.data).forEach(function (key) {
                                errores += key + ": " + err.response.data[key];
                                errores += "<br>";
                            });

                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al intentar transmitir el eDocument.",
                        footer: errores
                    });
                })
                .then(() => {
                    //this.cargar();
                    this.$refs.pagination_pw.filterData();
                    this.$root.$dialogLoader.hide();
                });
        },

        recuperarAcuse: function (id_edocument, no_operacion, edocument) {
            if (this.ws_password == '') {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se han configurado sellos digitales para el cliente: " + this.rfc,
                    footer: ""
                });
            } else {

                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var key = this.$local_storage.get("rfc") + "/edocuments/" + no_operacion + "/";
                var estatus = 2; //2-Recuperado

                var datos = {
                    tipo: 2, //1-Cove, 2-eDocument
                    documento: edocument,
                    path: key,
                    token: {
                        ws_rfc: this.rfc,
                        ws_password: this.ws_password
                    }
                };
                axios.post(this.$hostname + "vucem/get_acuse/", datos)
                    .then(res => {

                        this.downloadFile("Acuse_" + edocument, no_operacion, "pdf");

                    })
                    .catch(err => {
                        estatus = 3; //3-Errores

                        var errores = "";
                        if (err.response.data != undefined) {
                            if (err.response.data.mensaje != undefined) {
                                if (typeof err.response.data.mensaje == "string")
                                    errores += err.response.data.mensaje;
                                else
                                    errores += err.response.data.mensaje[0];

                            } else {
                                Object.keys(err.response.data).forEach(function (key) {
                                    if (typeof err.response.data[key] == 'string')
                                        errores += key + ": " + err.response.data[key];
                                    else if (typeof err.response.data[key] == 'object') {
                                        Object.keys(err.response.data[key]).forEach(function (key2) {
                                            if (typeof err.response.data[key][key2] == 'string')
                                                errores += key + ": " + err.response.data[key][key2];
                                            else if (typeof err.response.data[key][key2] == 'object')
                                                errores += key2 + ": " + err.response.data[key][key2][0];
                                        });
                                    }
                                    //errores += key + ": " + err.response.data[key][0];
                                    errores += "<br>";
                                });

                            }
                        }
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al recuperar el acuse.",
                            footer: errores
                        });
                        console.log(err);
                    }).then(() => {
                        axios.post(this.URL + "actualiza_acuse_edocument/", {
                                edocument: edocument,
                                id: id_edocument,
                                estatus: estatus
                            })
                            .then(res => {

                            }).catch(err => {

                            });
                        //this.cargar();
                        this.$refs.pagination_pw.filterData();
                    });
            }
        },

        deleteRegistro: function (id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: id
            };
            axios.post(this.URL + "elimina_edocument/", datos)
                .then(res => {

                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se eliminó correctamente.",
                        footer: ""
                    });

                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al eliminar el registro.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    //this.cargar();
                    this.$refs.pagination_pw.filterData();
                    this.$root.$dialogLoader.hide();
                });
        },

        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },

        downloadFile: function (nombre, no_operacion, tipo) {
            //Tipo: xml, pdf
            var rfc = this.rfc + "/edocuments/" + no_operacion + "/";
            var key = rfc + nombre + "." + tipo;

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            /*axios.post(this.$hostname + "s3/download/", datos, {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Allow: "POST",
                        "cache-control": "no-cache",
                        //responseType: "arraybuffer"
                    }
                )
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                    url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre + "." + tipo;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });*/

            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        //a.download = name[name.length - 1];
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        send: function () {
            if (this.file_c == null) {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Debe seleccionar un archivo PDF para transmitir.",
                });
                return false;
            }
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                let datos = {
                    rfc: this.rfc,
                    fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
                    usuario_email: this.$local_storage.get("email"),
                    tipo_documento: this.model.tipo_documento,
                    nombre_proceso: this.model.nombre_proceso,
                    nombre_documento: this.model.nombre_documento,
                    rfc_consulta: this.model.rfc_consulta,
                    email: this.model.email,
                    file: this.file_c,
                };
                //console.log(datos);

                axios.post(this.$apiVucem + "transmitir_edocument/save_edocument/", datos)
                    .then(() => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se guardó correctamente. Puede transmitir el eDocument cuando lo requiera.",
                            footer: ""
                        });
                    })
                    .catch(err => {
                        //console.log(err.response);
                        var errores = "";
                        if (err.response.data != undefined) {
                            if (err.response.data.mensaje != undefined) {
                                if (typeof err.response.data.mensaje == "string")
                                    errores += err.response.data.mensaje;
                                else
                                    errores += err.response.data.mensaje[0];

                            } else {
                                Object.keys(err.response.data).forEach(function (key) {
                                    errores += key + ": " + err.response.data[key];
                                    errores += "<br>";
                                });

                            }
                        }
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar el registro.",
                            footer: errores
                        });
                    })
                    .then(() => {
                        //this.cargar();
                        this.$refs.pagination_pw.filterData();
                        this.modal = false;
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        downloadZipEvidencia: function(id_edoc, no_operacion, intento = 0) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
           
            var nombreZip = no_operacion.toString() + "_evidencias.zip";
            
            var key = this.$local_storage.get("rfc") + "/reportes/" + nombreZip;

            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }
            let nombre_download = key.split("/").pop();
            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if (intento == 0) {
                            thisObj.generaZipEvidencia(id_edoc, no_operacion);
                        } else if (intento > 4) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar ZIP. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            setTimeout(function() {
                                thisObj.downloadZipEvidencia(id_edoc, no_operacion, intento + 1);
                            }, 10000); //Damos tiempo para generar el zip (10 seg)

                        }

                    }
                }).catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
                        if (intento == 0)
                            thisObj.generaZipEvidencia(id_edoc, no_operacion);
                        else
                            setTimeout(function() {
                                thisObj.downloadZipEvidencia(id_edoc, no_operacion, intento + 1);
                            }, 10000); //Damos tiempo para generar el zip (10 seg)

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }
                });

            },
              getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
     cargarRfcsConsulta: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.rfcs_consulta = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los rfcs de consulta.",
            footer: ""
          });
        });
    },
    getNombreRfcConsulta: function (record) {
      return record.rfc + " - " + record.nombre + " - " + record.patente;
    },
            generaZipEvidencia: function(id_edoc, no_operacion) {
                var datos = {
                    rfc: this.$local_storage.get("rfc"),
                    id_edocument: id_edoc,
                    no_operacion: no_operacion,
                    reporte_url: "/reportes_vucem/genera_zip_evidencias_edoc/",
                    nombre_reporte: "Zip Evidencias eDocument",
                    tipo: "ZIP_Evidencias_eDoc",
                    usuario: this.$local_storage.get("id_usuario"),
                };
                var thisObj = this;
                axios.post(this.$hostname + "reportes/save_reporte/", datos)
                    .then(res => {
                        thisObj.downloadZipEvidencia(id_edoc, no_operacion, 1);
                    }).catch(error => {
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
                            var mensaje = error.response.data.mensaje;
                            this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                            });
                        } else { //Si es un timeout intentamos descargar el archivo
                            thisObj.downloadZipEvidencia(id_edoc, no_operacion, 1);
                        }
                        console.log(error);
                    });
            },
    },

    created: function () {
        this.URL = this.$hostname + "transmitir_edocument/";
        this.cliente = this.$local_storage.get("id_cliente");
        this.usuario = this.$local_storage.get("id_usuario");
        this.rfc = this.$local_storage.get("rfc");
        this.$root.$dialogLoader.hide();
        this.cargarTiposDocumento();
        this.cargarRfcsConsulta();
        this.cargar();

    },    
};
</script>

<style>
#lista_edocuments tr td:nth-child(4) {
    width: 260px;
    font-size: xx-small;
}

#lista_edocuments tr td:nth-child(2) {
    font-size: small ;
}

#lista_edocuments tr td:nth-child(3) {
    font-size: small ;
}

#lista_edocuments {
    font-size: small;
}
</style>
